import React, { useEffect, useState } from 'react'
import { DayPilot, DayPilotCalendar, DayPilotNavigator } from "@daypilot/daypilot-lite-react";
import { AgendamentosService } from '../../services/api/Agendamentos/AgendamentosService';
import AgendaCadModal from './AgendaCadModal';
import { Button, Col, Row, Form, Card } from 'react-bootstrap';
import { tiposServicosUtils } from '../../utils/tiposServicosUtils';
import ModalSimNao from '../../components/ModalSimNao'
import { ProfissionaisService } from '../../services/api/Profissionais/ProfissionaisService';
import { statusAgendamentosUtils } from '../../utils/statusAgendamentosUtils'
import { EmpresasService } from '../../services/api/Empresas/EmpresasService'
import Loading from '../../components/Loader/Loading';
import { useMediaQuery } from '@custom-react-hooks/use-media-query';
import AgendamentosListMobile from './AgendamentosListMobile';
import AgendaCadModalVer from './AgendaCadModalVer';
import { tiposAgendamentosUtils } from '../../utils/tiposAgendamentosUtils'
import './agenda.css'
import { FilterBar } from './FilterBar';
import { ListView } from './ListView';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AgendaComp = ({ listPermissoes = { listPermissoes } }) => {
  const [calendarLateral, setCalendarLateral] = useState(null)
  const [calendar, setCalendar] = useState(null);
  const [view, setView] = useState("Day");
  const [startDate, setStartDate] = useState(DayPilot.Date.today());
  const [dayView, setDayView] = useState();
  const [events, setEvents] = useState([]);
  const [showModalCad, setShowModalCad] = useState(false)
  const [showModalVer, setShowModalVer] = useState(false)
  const [dadosModal, setDadosModal] = useState(null)
  const [showModalConfirm, setShowModalConfirm] = useState(false)
  const [horaFuncionamento, setHoraFuncionamento] = useState({ abertura: 8, fechamento: 17 })
  const [listProfissionais, setListProfissionais] = useState([])
  const [filtros, setFiltros] = useState({ tiposServicosId: 1 })
  const [profissionalSelected, setProfissionalSelected] = useState(null);
  const [eventsCal, setEventsCal] = useState({ events: [] })
  const [isLoading, setIsloading] = useState(true)
  const [isLoadingAgenda, setIsloadingAgenda] = useState(true)
  const [listAgendamentos, setListAgendamentos] = useState([])
  const [msgDelete, setShowMsgDelete] = useState('')


  const isMobile = useMediaQuery('(max-width: 600px)');

  const fetchEmpresas = async () => {
    setIsloading(true);
    const data = await EmpresasService.getAll()
    if (data.success) {
      let ab = data.data[0].abertura.split(':')
      let fh = data.data[0].fechamento.split(':')

      setHoraFuncionamento({
        abertura: parseInt(ab[0]),
        fechamento: parseInt(fh[0])
      })
    }
    setIsloading(false);
  }


  useEffect(() => {
    fetchEmpresas()

  }, [])


  ///Filtros
  const fetchProfissionais = async (tiposServicosId) => {

    let filtrosProf = { tiposServicosId: tiposServicosId }
    const data = await ProfissionaisService.getAll(null, filtrosProf);
    // console.log(data)
    if (data.success) {
      setListProfissionais(data.data)
      if (data.data.length > 0) {
        setFiltros({
          tiposServicosId: filtrosProf.tiposServicosId,
          profissionaisId: data.data[0].id
        })
      }

    }

  }


  useEffect(() => {
    let profSel = listProfissionais.find(item => item.id == filtros?.profissionaisId)
    setProfissionalSelected(profSel)

    fetchAgendamentos()

    fetchAgendamentoDatas()

  }, [filtros?.profissionaisId])

  const handleChangeFiltro = async (e) => {

    const { name, value } = e.target
    if (name == 'filtro_profissionais') {
      setFiltros({
        ...filtros,
        profissionaisId: value,
      })



    }
    if (name == 'filtro_tp_servico') {

      setFiltros({
        ...filtros,
        tiposServicosId: value,
      })

      if (value != 1) {
        // console.log(value)

        await fetchProfissionais(value)
      } else {
        setFiltros({
          ...filtros,
          profissionaisId: '',
          tiposServicosId: value
        })
        setListProfissionais([])
      }
    }
  }


  const getCorStatusAgendamento = (status) => {

    const listCores = statusAgendamentosUtils();
    const selected = listCores.find(item => item.id == status)
    //console.log(selected)

    return {
      backColor: selected?.colorLight,
      borderColor: selected?.colorLight,
      cssClass: selected?.classEvent
    }
  }


  const dataAgendaAdapter = (dates) => {
    let eventos = []
    dates.map((item) => {
      console.log(dates)
      let corStatus = getCorStatusAgendamento(item.status)
      let tipoAgendamento = tiposAgendamentosUtils().find(tp => tp.id == item.tipoAgendamentoId)
      if (item?.tipoAgendamentoId != 1) {
        corStatus.backColor = tipoAgendamento?.colorLight
        corStatus.borderColor = tipoAgendamento?.colorLight
        corStatus.cssClass = tipoAgendamento?.classEvent
      }

   let servico = (item?.agendamento_itens.length>0)?item?.agendamento_itens[0].nomeServico:'';


      let obs = (item?.observacoes) ? ' - <b style="font-weight:500;">Obs:</b> ' + item?.observacoes : '';

      let dadosNome = (item.tipoAgendamentoId.toString() != '1') ? '<span class="bold '+tipoAgendamento?.classColorTitle+'">' + tipoAgendamento?.nome + '</span>'  : '<span class="bold ">'+ item?.clientes?.nome+ '</span>'+ ' | ' +  '<span class="bold">'+item?.animais?.nome+ '</span>  <br>'+servico
      eventos.push({
        id: item.id,
        html: dadosNome + obs, //conteudo
        toolTip: (item.tipoAgendamentoId.toString() != '1') ?  + tipoAgendamento?.nome  : item?.clientes?.nome+ ' | ' + item?.animais?.nome+' '+servico,  //title
        start: item.inicio.replace(' ', 'T'),
        end: (item.termino) ? item.termino.replace(' ', 'T') : item.inicio.replace(' ', 'T'),
        ...corStatus, // Teal background
        ...filtros
      })
    })
    //   handleHoraFuncionamento(profSel)
    setEvents(eventos)
    // console.log(eventos)

  }

  //manipulando os eventos
  const editVerEvent = async (e) => {
    setShowModalVer(true)
    argsToModal(e.data);
  };
  const editEvent = async (argsModal) => {
    setShowModalCad(true)
    setShowModalVer(false)
    argsToModal(argsModal);
  };

  const updateEvent = async (args) => {
    //console.log(args.e.data)
    let dataArgs = args.e.data
    if (dataArgs.id != '') {
      let form = new FormData();
      form.append('inicio', dataArgs.start.value.replace('T', ' '))
      form.append('termino', dataArgs.end.value.replace('T', ' '))
      //console.log(form)
      const atualiza = await AgendamentosService.atualizaDataHora(dataArgs.id, form)
      fetchAgendamentos()

    }

  }




  const handleEventMove = (args) => {
    updateEvent(args)
  }

  const handleEventResize = (args) => {
    updateEvent(args)
  }

  const handleEventDelete = (args, id) => {
    // console.log(args)
    let dados = null
    if (id != undefined) {
      dados = { id: id }
    } else {
      dados = { id: args.source.data.id }
    }

    setDadosModal(dados)
    setShowModalConfirm(true)

    if (listPermissoes?.excluir) {
      setShowMsgDelete('Tem certeza que desejar excluir este agendamento?')
    } else {
      setShowMsgDelete('Você não tem permissão para desmarcar')
    }
  }


  const handleDeleteAgendamento = async () => {
    //console.log(dadosModal)

    const dataAgendamento = await AgendamentosService.deleteById(dadosModal.id);
    //console.log(dataAgendamento)
    if (dataAgendamento.success) {
      setShowModalConfirm(false)
      setDadosModal(null)
      fetchAgendamentos()
    }
  }


  //fim manipula evento



  const fetchAgendamentos = async () => {
    setIsloadingAgenda(true)
    let filtrosAgenda = {
      withAnimaisClientes: true,
      withAgendamentosItens: true,
      tiposServicosId: filtros?.tiposServicosId,
      profissionaisId: filtros?.profissionaisId,
    };

    const dataIni = startDate.toString().split('T')
    let dataTermino = ''

    if (view == 'Week') {
      dataTermino = startDate.addDays(6).toString().split('T');
      dataTermino = dataTermino[0]
    }
    // console.log(filtrosAgenda)
    //  console.log(filtros)


    const dataAgendamento = await AgendamentosService.getAll(dataIni[0], dataTermino, filtrosAgenda);
    // console.log(dataAgendamento)
    if (dataAgendamento.success) {
      setListAgendamentos(dataAgendamento.data)
      dataAgendaAdapter(dataAgendamento.data)
    }


    setIsloadingAgenda(false)
  }

  const fetchAgendamentoDatas = async () => {


    if (calendarLateral != undefined) {
      let filtrosAgenda = {
        tiposServicosId: filtros?.tiposServicosId,
        profissionaisId: filtros?.profissionaisId,
        data: calendarLateral.visibleStart().toString().substring(0, 10),
        dataFinal: calendarLateral.visibleEnd().toString().substring(0, 10),
      };

      const result = await AgendamentosService.getDatasByMes(2, filtrosAgenda)


      if (result.success) {
        //  console.log(result.data)
        let eventsDate = []
        result.data.map((item, index) => {
          eventsDate.push({
            id: index,
            html: null, //conteudo
            text: null,  //title
            start: item,
            end: item

          })
        })

        //console.log(eventsDate)
        setEventsCal({
          events: eventsDate

        })
      }
    }
  }



  useEffect(() => {

    fetchAgendamentos()
  }, [startDate]);

  useEffect(() => {

    fetchAgendamentoDatas()
  }, [calendarLateral]);





  const onTimeRangeSelected = async (args) => {

    console.log(args)
    setShowModalCad(true)
    argsToModal(args);
  };

  const handleChangeNavigator = (args) => {
    fetchAgendamentoDatas()
  }

  const argsToModal = (args) => {

    let dados = {
      id: args.id,
      start: args.start.toString(),
    }
    setDadosModal(dados)

  }
  const handleClickMobileEnvent = (id, start) => {

    argsToModal({
      id: id,
      start: start
    })
    console.log(start)
    setShowModalCad(true)
  }




  const config = {
    locale: 'pt-br',
    headerDateFormat: "dd/MM/yyyy",
    durationBarVisible: false,
    businessBeginsHour: horaFuncionamento.abertura,
    businessEndsHour: horaFuncionamento.fechamento,
    showNonBusiness: false,
    timeRangeSelectedHandling: "Enabled",
    showAllDayEvents: true,
    cellHeight: 60,
    onEventClick: async args => {
      await editVerEvent(args.e);
    },
    eventMoveHandling: "Update",
    onEventMoved: (args) => {
      handleEventMove(args)
    },
    eventResizeHandling: "Update",
    onEventResized: (args) => {
      handleEventResize(args)
    },
    eventDeleteHandling: "Delete",
    onEventDelete: (args) => {
      handleEventDelete(args)
    },
    eventClickHandling: "Enabled",
    eventHoverHandling: "Bubble",
    contextMenu: new DayPilot.Menu({
      items: [

        {
          text: "-"
        },
        {
          text: "Alterar...",
          onClick: args => {
            const event = args.source;
            const fetchEdit = async (event) => {
              await editEvent(event);
            }
            fetchEdit(event)


          }
        },
        {
          text: "Excluir",
          onClick: async args => {
            handleEventDelete(args)
            // calendar.events.remove(args.source.data);
          },
        },
      ]
    }),
    onBeforeCellRender: (args) => {
      //Alterar as células(Exemplo bloquear horarioque o profissional atende)


      ///FAzaer verificação dos horários de funcionamento e lançar os horários que não trabalha como eventos
     // console.log(args)

     // args.data.areas = { right: 2, top: 2, width: 24, height: 24, icon: "fas fa-user" }
      if (profissionalSelected != undefined) {

        let verifica = profissionalSelected?.profissional_agenda.find(item => (item.diasSemanasId - 1) == args.cell.start.getDayOfWeek())

        if (verifica != undefined && verifica?.status == 1) {

          let dataCal = args.cell.start.value.split('T')
          let inicio = new DayPilot.Date(dataCal[0] + 'T' + verifica.inicio)
          let fim = new DayPilot.Date(dataCal[0] + 'T' + verifica.termino)

          if (args.cell.start < inicio) {
            args.cell.properties.backColor = "#f8e1e1ff"
            args.cell.properties.html = '<div class="text-center" style="color:#ed7b86;font-weight: 500;"title="Não atende"></div> '
             args.cell.properties.title = 'Não atende'
            args.cell.properties.disabled = true
          }
          if (fim < args.cell.start) {
            args.cell.properties.backColor = "#f8e1e1ff"
            args.cell.properties.html = '<div class="text-center" style="color:#ed7b86;font-weight: 500;"title="Não atende"></div> '
            args.cell.properties.disabled = true
          }

        } else {
          args.cell.properties.backColor = "#f8e1e1ff"
          args.cell.properties.html = '<div class="text-center" style="color:#ed7b86;font-weight: 500;" title="Não atende"></div> '
          args.cell.properties.disabled = true

        }

      } else {

      }

    },

  };
  //console.log(calendarLateral)
  return (
    <>

      {(isLoading) ? <Loading /> : (
        <>
          <div id="divAgenda">

            <Col id="agenda-menu" className='box-fundo'>
              <div className='mb-15'>
                <Form.Label style={{ textAlign: 'left' }}>Tipo de servico:</Form.Label>
                <Form.Select onChange={(e) => handleChangeFiltro(e)} name='filtro_tp_servico'>
                  {tiposServicosUtils()?.map((item) => (
                    <>
                      <option value={item.id}>{item.nome}</option>
                    </>
                  ))}
                </Form.Select>

              </div>


              <div className='clearfix'></div>
              <div className='mb-15' style={{ display: (listProfissionais.length > 0) ? '' : 'none' }}>
                <Form.Label style={{ textAlign: 'left' }}>Profissionais</Form.Label>
                <Form.Select onChange={(e) => handleChangeFiltro(e)} name='filtro_profissionais'>
                  {listProfissionais?.map((item) => (
                    <>
                      <option value={item.id}>{item.nome} |
                        {

                          item?.profissional_tipos_servicos?.map((itemProfTp) => (
                            ' ' + itemProfTp?.tipos_servicos?.nome
                          ))
                        }
                      </option>

                    </>
                  ))}
                </Form.Select>
              </div>
              <hr></hr>
              <div className="navigator text-center">
                <DayPilotNavigator
                  cellWidth="Auto"
                  selectMode={(view == 'Lista') ? 'Day' : view}
                  showMonths={1}
                  onTimeRangeSelected={args => setStartDate(args.day)}
                  locale='pt-br'
                  events={eventsCal.events}
                  controlRef={setCalendarLateral}
                  onVisibleRangeChanged={args => handleChangeNavigator(args)}
                />
              </div>

                 <Button style={{width:'100%'}} variant='success' className='mt-15' size='sm' onClick={() => handleClickMobileEnvent(undefined, startDate)}><FontAwesomeIcon icon={faCalendarCheck} className='mr-5' /> Agendar</Button>

            </Col>




            { /*(isMobile) ?
              <>
                <div className="box-fundo" style={{ width: '100%' }}>
                  <h4 className='text-center mb-15'>{(profissionalSelected?.nome) ? profissionalSelected?.nome : 'Hospedagem'}</h4>

                  <AgendamentosListMobile
                    listAgendamentos={listAgendamentos}
                    handleClickMobileEnvent={handleClickMobileEnvent}
                    handleEventDelete={handleEventDelete}
                    startDate={startDate}

                  />
                </div>
              </>

              :*/ (
                <>
                  {(isLoadingAgenda) ? <div style={{ position: 'relative', minHeight: '400px' }}><Loading /></div> : (
                    <>
                      <Col id="agenda-calendario">
                        <div className="">

                          <FilterBar setView={setView}
                            setStartDate={setStartDate}
                            view={view}
                            today={DayPilot.Date.today()}
                            profissionalNome={(profissionalSelected?.nome) ? profissionalSelected?.nome : 'Hospedagem'}
                          />
                          <DayPilotCalendar
                            eventArrangement="Cascade"
                            {...config}
                            viewType={"Day"}
                            startDate={startDate}
                            events={events}
                            visible={view === "Day"}
                            durationBarVisible={false}
                            onTimeRangeSelected={onTimeRangeSelected}
                            controlRef={setCalendar}
                          />
                          <DayPilotCalendar
                            {...config}
                            viewType={"Week"}
                            startDate={startDate}
                            events={events}
                            visible={view === "Week"}
                            durationBarVisible={false}
                            onTimeRangeSelected={onTimeRangeSelected}
                            controlRef={setCalendar}
                          />
                        </div>

                        {(view == 'Lista' && <AgendamentosListMobile
                          listAgendamentos={listAgendamentos}
                          handleClickMobileEnvent={handleClickMobileEnvent}
                          handleEventDelete={handleEventDelete}
                          startDate={startDate}

                        />)}

                      </Col>

                    </>
                  )}

                </>

              )}




          </div>
          <ModalSimNao show={showModalConfirm} handleClose={() => setShowModalConfirm(false)}
            handleConfirm={() => handleDeleteAgendamento()}
            exibeBotoes={false}
          >
            {msgDelete}
          </ModalSimNao>

          <AgendaCadModalVer
            editEvent={editEvent}
            show={showModalVer}
            args={dadosModal}
            refreshAgendamentos={() => fetchAgendamentos()}
            handleClose={() => setShowModalVer(false)}
            filtrosAgenda={filtros}
            dadosProfissional={profissionalSelected}
            listPermissoes={listPermissoes}
          ></AgendaCadModalVer>
          {<AgendaCadModal
            show={showModalCad}
            args={dadosModal}
            refreshAgendamentos={() => fetchAgendamentos()}
            handleClose={() => setShowModalCad(false)}
            filtrosAgenda={filtros}
            dadosProfissional={profissionalSelected}
            listPermissoes={listPermissoes}
          ></AgendaCadModal>}
        </>)
      }
    </>


  )



}

export default AgendaComp